import {FC} from "react";
import {Card, Col, Row} from "react-bootstrap";
import useConstituentConversions from "@oldDashboard/legacyHooks/useConstituentConversions";
import ReactApexChart from "react-apexcharts";
import Loader from "@/components/common/loader/loader";

interface ConstituentConversionsTileProps { data: any, affiliateSelected: String, launchSelected: String, searching: boolean }

const ConstituentConversionsTile: FC<ConstituentConversionsTileProps> = (props) => {
    const { data, launchSelected, affiliateSelected, searching } = props;
    const { isLoading, chartData } = useConstituentConversions({affiliateSelected, launchSelected, searching});
    if(data.length == 0 || (!chartData?.series && !chartData?.options)) return null;
    if(!data.show_student_conversions_tile) return null;
    return (
        <Row>
            <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                <Card className="custom-card" style={{height: '250px'}}>
                    { isLoading && <Loader/> }
                    <Card.Header>
                        <Card.Title>Student Conversions Over Time</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <ReactApexChart
                            options={chartData?.options}
                            series={chartData?.series}
                            height={175}
                            style={{marginTop: '-25px'}}
                        />
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default ConstituentConversionsTile;
